import 'css/src/components/common/dashboard-sidebar.module.scss';

import React from 'react';

import { RoleEnum, Urls } from 'js/src/client';
import HeaderLogo from 'js/src/components/common/HeaderLogo';
import UpsellIcon from 'js/src/components/common/ui/UpsellIcon';

/**
 * The SettingsSidebar is used to frame all of the "settings" pages. That includes
 * pages like the workspace settings, team member settings, and account settings.
 */

const SettingsSidebar = React.memo(function SettingsSidebar() {
    const currUrl = window.location.pathname as Urls;
    return (
        <div className="dashboard-sidebar">
            <div className="overflow-container overflow-y-auto">
                <div className="m-l5-24">
                    <HeaderLogo />
                </div>
                <ul className="navigation navigation-main navigation-accordion">
                    {SERVER.USER.role === RoleEnum.ADMIN && (
                        <li className={currUrl === Urls.WORKSPACE_SETTINGS ? 'active' : ''}>
                            <a href={Urls.WORKSPACE_SETTINGS}>
                                <i translate="no" className="material-symbols-outlined">
                                    work
                                </i>
                                <span>Workspaces</span>
                            </a>
                        </li>
                    )}
                    {SERVER.USER.role === RoleEnum.ADMIN && (
                        <li className={currUrl === Urls.TEAM_MANAGEMENT ? 'active' : ''}>
                            <a href={Urls.TEAM_MANAGEMENT}>
                                <i translate="no" className="material-symbols-outlined">
                                    people_alt
                                </i>
                                <span>Team</span>
                            </a>
                        </li>
                    )}
                    {SERVER.USER.role === RoleEnum.ADMIN && (
                        <li className={currUrl === Urls.BILLING_SETTINGS ? 'active' : ''}>
                            <a href={Urls.BILLING_SETTINGS}>
                                <i translate="no" className="material-symbols-outlined">
                                    credit_card
                                </i>
                                <span>Billing</span>
                            </a>
                        </li>
                    )}
                    <li className={currUrl === Urls.ACCOUNT ? 'active' : ''}>
                        <a href={Urls.ACCOUNT}>
                            <i translate="no" className="material-symbols-outlined">
                                settings
                            </i>
                            <span>Account settings</span>
                        </a>
                    </li>
                    <li className={currUrl === Urls.PRIVACY_SETTINGS ? 'active' : ''}>
                        <a href={Urls.PRIVACY_SETTINGS}>
                            <i translate="no" className="material-symbols-outlined">
                                lock
                            </i>
                            <span>Privacy settings</span>
                        </a>
                    </li>
                    {(SERVER.USER.role === RoleEnum.ADMIN ||
                        SERVER.USER.role === RoleEnum.EDITOR) && (
                        <li className={currUrl === Urls.VIDEO_SETTINGS ? 'active' : ''}>
                            <a href={Urls.VIDEO_SETTINGS}>
                                <i translate="no" className="material-symbols-outlined">
                                    video_settings
                                </i>
                                <span>Video settings</span>
                            </a>
                        </li>
                    )}
                    {SERVER.USER.role === RoleEnum.ADMIN && (
                        <li className={currUrl === Urls.AUDIT_LOG ? 'active' : ''}>
                            <a href={Urls.AUDIT_LOG}>
                                <i translate="no" className="material-symbols-outlined">
                                    find_in_page
                                </i>
                                <span>
                                    Audit log{' '}
                                    {!SERVER.USER.capabilities.has_audit_log && (
                                        <UpsellIcon
                                            className="material-symbols-outlined--upsell"
                                            isOutlined
                                        />
                                    )}
                                </span>
                            </a>
                        </li>
                    )}
                    {(SERVER.USER.role === RoleEnum.ADMIN ||
                        SERVER.USER.role === RoleEnum.EDITOR) && (
                        <li className={currUrl === Urls.COPYRIGHT_CLAIMS ? 'active' : ''}>
                            <a href={Urls.COPYRIGHT_CLAIMS}>
                                <i translate="no" className="material-symbols-outlined">
                                    gavel
                                </i>
                                <span>Copyright claims</span>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
});

export default SettingsSidebar;
